import {useContext, useEffect, useState} from 'react'
import {Row, Form, Button} from 'react-bootstrap'
import 'react-bootstrap-typeahead/css/Typeahead.css'
import { ListDocuments } from './ListDocuments'
import { PartnerEditShowContext } from '../partner-edit/PartnerEditShowContexts'


const KitDocumentoModalForm = () => {
  const {idProceso} = useContext(PartnerEditShowContext)

  return (
    <>
      <Form >
        <Row className='mb-3'>
            <ListDocuments id={idProceso} />
        </Row>
      </Form>
    </>
  )
}

export {KitDocumentoModalForm}
